import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import InsuranceVerification from "./pages/InsuranceVerification";
import DentalOrthodontics from "./pages/DentalOrthodontics";
import Hospitals from "./pages/Hospitals";
import InsuranceProviders from "./pages/InsuranceProviders";
import ARDebtCollections from "./pages/ARDebtCollections";
import Pricing from "./pages/Pricing";
import HipaaPolicies from "./pages/HipaaPolicies";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Contact from "./pages/Contact";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/insurance-verification" element={<InsuranceVerification />} />
          <Route path="/dental-orthodontics" element={<DentalOrthodontics />} />
          <Route path="/for-hospitals-clinics" element={<Hospitals />} />
          <Route path="/for-insurance-providers" element={<InsuranceProviders />} />
          <Route path="/ar-debt-collections" element={<ARDebtCollections />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/hipaa-privacy-policies" element={<HipaaPolicies />} />
          <Route path="/privacy-policies" element={<PrivacyPolicy />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Layout>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
